import { useMemo, useState } from 'react';

import { transformWeightConditions } from '@jane/business-admin/util';
/* eslint-disable-next-line no-restricted-imports */
import type { WeightValueCondition } from '@jane/shared/models';

import type { ConditionType } from '../../form';
import { ConditionByModal } from '../generic_components/ConditionByModal';
import type { Condition } from '../generic_components/ConditionByModal';
import { WeightValuesModal } from './WeightValuesModal';

export const WeightValuesConditions = ({
  conditions,
  onConditionsUpdate,
  type,
}: {
  conditions: WeightValueCondition[];
  onConditionsUpdate: (data: WeightValueCondition[]) => void;
  type: ConditionType.WeightValues | ConditionType.ExcludeWeightValues;
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onUpdate = (data: Condition[]) => {
    const dataValues = data.map((condition) => condition.value);
    onConditionsUpdate(dataValues);
  };

  const onSaveModal = (data: WeightValueCondition[]) => {
    onConditionsUpdate(data);
  };

  const parsedConditions = useMemo(() => {
    return transformWeightConditions(conditions);
  }, [conditions]);

  return (
    <>
      <ConditionByModal
        onOpenModal={() => setModalOpen(true)}
        type={type}
        conditions={parsedConditions}
        conditionsLoading={false}
        onConditionsUpdate={onUpdate}
      />
      {modalOpen && (
        <WeightValuesModal
          conditions={conditions}
          closeModal={() => setModalOpen(false)}
          onSubmit={onSaveModal}
        />
      )}
    </>
  );
};
